export const CONFIGURED_SERVICE_TABS_ID = {
  DETAILS_PRICING_TAB_ID: 'details-pricing',
  FEES_TAXES_TAB_ID: 'fees-taxes',
  ADVANCED_TAB_ID: 'advanced',
  MAP_ROUTING_TAB_ID: 'map-routing',
}

export const CONFIGURED_SERVICE_TABS_ID_LIST = Object.values(CONFIGURED_SERVICE_TABS_ID)
